import React from "react";

import { StandingSection as FcbStandingSection } from "../../../../frontend/templates/fcb/ImageTable/Index";
import { StandingSection as WomensStandingSection } from "../../../../frontend/templates/womens/ImageTable/Index";
require("../../../../frontend/templates/fcb/ImageTable/style/style.scss");

// Editor-canvas preview for fcb_image_table. The editor paints its own
// draggable background layers, so the only thing this contributes is the
// standings block on top of them - and that comes from the template itself via
// StandingSection, so this preview, the SaveModal preview and the exported
// template can no longer disagree. Nothing here restates the template's
// sizing: it renders at real pixel size inside `.template-container`, which
// the editor stylesheet scales down, the same approach resultContent.js uses.
export default function Index({ data, manualEntries, ...props }) {
    const templateName = data?.template_name ?? "";
    // Each client owns its image table, so the preview has to render that
    // client's StandingSection rather than always FCB's.
    const StandingSection =
        templateName === "womens_image_table" ? WomensStandingSection : FcbStandingSection;
    const id = `${templateName}_${data?.uuid}`;

    return (
        <div className={`comp-template-preview table-template-preview ${props.customClass}`} style={{
            width: 0,
            height: 0
        }}>
            <div className="template-container">
                <div id={id} className={`T_${templateName}`}>
                    <StandingSection data={data} manualEntries={manualEntries} />
                </div>
            </div>
        </div>
    );
}
